import { render, staticRenderFns } from "./MethodAdd.vue?vue&type=template&id=a168db56&"
import script from "./MethodAdd.vue?vue&type=script&lang=js&"
export * from "./MethodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports